export default "__VITE_ASSET__C5MLpVo4__"